<template>
    <div class="qqmap-route-conatiner">
        <div class="route-head-section">

            <div class="startAndEnd-chunk">

                <div class="back" @click="back">
                    <i class="iconfont icon-left-01"></i>
                </div>

                <div class="input-group">

                    <div class="l">
                        <div class="wrap">
                            <i class="start dot"></i>
                            <i class="rail"></i>
                            <i class="end dot"></i>
                        </div>
                    </div>

                    <div class="r">

                        <div class="box start" @click="selected('start')">
                            <input type="text" v-model="startInput" placeholder="请选择起点" readonly>
                        </div>

                        <div class="box end" @click="selected('end')">
                            <input type="text" v-model="endInput" placeholder="请选择终点" readonly>
                        </div>

                    </div>

                </div>

                <div class="change-route">
                    <i class="iconfont icon-luxian" @click="changeRoute"></i>
                </div>

            </div>

            <div class="vechile-chunk">
                <a v-for="(item,index) in vechile" :class="{active:index == vechileIndex}" @click="sVechile(item,index)">
                    <i class="iconfont" :class="[item.icon]"></i>
                    <span>{{item.name}}</span>
                </a>
            </div>

        </div>
        <div class="route-body-section">

            <!--路线展示-->
            <div class="routeLine-chunk">

                <ul v-if="routeLines.length">
                    <li v-for="(item,index) in routeLines" @click="routeLinesEvent(item)">
                        <div class="l"><span>{{index + 1}}</span></div>
                        <div class="r">
                            <p class="p1">{{item.name}}</p>
                            <p class="p2">{{item.time}}</p>
                        </div>
                    </li>
                </ul>

                <div class="load-box" v-else-if="routeLoad">
                    <div class="load">
                        <i class="iconfont icon-jiazai11"></i>
                        <i class="iconfont icon-location-2"></i>
                    </div>
                </div>

                <div class="empty-box" v-else>
                    <div class="wrap">
                        <i class="iconfont icon-luxian"></i>
                        <span>暂无该路线</span>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<script>

    export default {
        name: "Route",
        data(){
            return {
                vechileIndex:0,
                vechile:[
                    {
                        name:'乘车',
                        icon:'icon-gongjiaoche'
                    },
                    {
                        name:'驾车',
                        icon:'icon-xiaoche'
                    },
                ],

                routeLines:[],

                routeLoad:false,

                startInput:'',
                endInput:'',

                enterType:0,        //0 无 1：地图 2：搜索 3:室内地图
            }
        },
        methods:{

            back(){

               if(this.enterType == 1){
                   this.$router.replace({
                       path:'/qqMap',
                       query:{
                           model:'traffic',
                           trafficeIndex:this.$route.query.trafficeIndex
                       }
                   });
               }else{
                   this.$router.replace('/qqSearch');
               }
                this.enterType = 0;
            },

            sVechile(item,index){
                //切换路线乘坐方式
                this.vechileIndex = index;
                this.getRoute(index + 1);

            },

            selected(type){
                let query = this.$route.query;
                query.from = false;
                query.type = this.vechileIndex + 1;//记录规划方式
                if(type == 'start')query.from = true;

                this.$router.replace({
                    path:'/qqSearch',
                    query:query
                })
            },

            transferService(start,end,callback){
                //驾车
                let $this = this,
                    transferService = $this.$qqmap.transferService = new qq.maps.TransferService({
                        map: $this.$qqmap.queryQQMap.map
                    });


                if($this.$qqmap.drivingService)$this.$qqmap.drivingService.clear();

                //成功
                transferService.setComplete(res=>{

                    if(res.type == qq.maps.ServiceResultType.MULTI_DESTINATION){
                        //起终点不唯一
                        console.log('起终点不唯一');

                        callback && callback(res,'1');

                    }

                    else{
                        callback && callback(res);
                    }

                })

                //失败
                transferService.setError(err=>{

                    if(err == qq.maps.ServiceErrorType.Error){
                        console.log('乘车服务器异常');
                    }

                    callback && callback(err,'err');
                })

                //设置策略 LEAST_TIME 较快捷 LEAST_TRANSFER 少换乘 LEAST_WALKING 少步行 NO_SUBWAY 不坐地铁
                transferService.setPolicy(qq.maps.TransferPolicy['LEAST_TIME']);

                //设置范围
                // transferService.setLocation('广东省');

                //设置搜索 (start:String | Poi | LatLng, end:String | Poi | LatLng);
                console.log('start',start,'end',end);

                setTimeout(()=>{
                    transferService.search(new qq.maps.LatLng(start.lat,start.lng),new qq.maps.LatLng(end.lat,end.lng));
                },200)

            },

            drivingService(start,end,callback){
                //乘车服务
                let $this = this,
                    drivingService = $this.$qqmap.drivingService = new qq.maps.DrivingService({
                        map: $this.$qqmap.queryQQMap.map
                    });

                if($this.$qqmap.transferService)$this.$qqmap.transferService.clear();

                //成功
                drivingService.setComplete(res=>{

                    if(res.type == qq.maps.ServiceResultType.MULTI_DESTINATION){
                        //起终点不唯一
                        console.log('起终点不唯一');

                        callback && callback(res,'1');

                    }

                    else{
                        callback && callback(res);
                    }

                })

                //失败
                drivingService.setError(err=>{

                    if(err == qq.maps.ServiceErrorType.Error){
                        console.log('乘车服务器异常');
                    }

                    callback && callback(err,'err');
                })

                //设置策略 LEAST_TIME 较快捷 LEAST_TRANSFER 少换乘 LEAST_WALKING 少步行 NO_SUBWAY 不坐地铁
                drivingService.setPolicy(qq.maps.DrivingPolicy['LEAST_TIME']);

                //设置范围
                // drivingService.setLocation('广东省');

                //设置搜索 (start:String | Poi | LatLng, end:String | Poi | LatLng);
                // console.log('start',start,'end',end);
                setTimeout(()=>{
                    drivingService.search(new qq.maps.LatLng(start.lat,start.lng),new qq.maps.LatLng(end.lat,end.lng));
                },300)
            },

            getGPSLocation(callee){

                let $this = this,
                    $mapWxReadyStatus = this.$mapEventManger.mapWxReadyStatus,

                    callback = ()=>{

                        if(this.wx.getLocation){
                            //获取地理位置
                            this.wx.getLocation({

                                type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'

                                success: location=>{
                                    // console.log('location',location);
                                    //记录当前经纬度
                                    $this.$qqmap.currentLatlng = new qq.maps.LatLng(location.latitude,location.longitude);
                                    callee(location)
                                },

                                error(){
                                    callee('获取GPS定位失败','err');
                                }
                            });

                        }
                        else{

                            callee('暂不支持GPS定位','err')

                        }
                    }

                if(!$mapWxReadyStatus){
                    this.$mapEventManger.mapWxReadyEvents.push(callback)
                }else{
                    callback && callback();
                }

            },

            getRoute(index,change){
                //index 1乘车 2驾车

                //获取路线
                let query = this.$route.query;

                let startPoi = query.start; //JSON.stringify({name:'我的位置',latlng:this.$qqmap.currentLatlng})

                let endPoi  = query.end || JSON.stringify({name:'深圳国际会展中心',latlng:this.$qqmap.centerLatlng,address:'广东省深圳市宝安区福海街道'});


                let callback = ()=>{
                    // console.log('query',query);
                    startPoi = JSON.parse(startPoi);
                    endPoi = JSON.parse(endPoi);

                    //交换起终点
                    if(change && this.startInput == startPoi.name){
                        let item = startPoi;
                        startPoi = endPoi;
                        endPoi = item;
                        item = '';

                        this.$route.query.start = JSON.stringify(startPoi);
                        this.$route.query.end = JSON.stringify(endPoi);

                    }


                    this.startInput = startPoi.name;
                    this.endInput = endPoi.name;

                    //选用name 或 经纬度作为查询点
                    let start = startPoi.latlng; //startPoi.id ? startPoi.name :
                    let end = endPoi.latlng; //endPoi.id ? endPoi.name :

                    //记录规划进入
                    if(!this.enterType)this.enterType = query.enterType;

                    //开启加载
                    this.routeLines = [];
                    this.routeLoad = true;

                    index = index || query.type || 1;

                    if(index !=2)this.vechileIndex = 0;

                    //多起终点取值
                    let getItem = (arr,refer)=>{

                        let r;

                        //校验id
                        if(refer.id){
                            r = arr.filter(item=>{
                                return item.id == refer.id;
                            })
                        }

                        //检验name
                        if(!r || !r.length){
                            r = arr.filter(item=>{
                                return item.name == refer.name;
                            })
                        }

                        r = r && r.length ? r[0] : arr[0];

                        return r;

                    };

                    if(start && end){

                        if(index == 2){

                            let callback = (res,type)=>{

                                // console.log('驾车规划路线',res);

                                if(type == 'err'){

                                    this.routeLoad = false;

                                }

                                else if(type == '1'){

                                    //起终点不唯一
                                    let s,e;
                                    s = getItem(res.detail.start,startPoi);
                                    e = getItem(res.detail.end,endPoi);

                                    // console.log('s',s,'e',e)

                                    if(s.latLng && s.latLng.lat && e.latLng && e.latLng.lat){
                                        this.drivingService(s.latLng,e.latLng,callback);
                                    }else{
                                        this.routeLoad = false;
                                    }

                                }

                                else{
                                    this.routeLoad = false;
                                    this.routeLines = [];
                                    if(res.detail.routes && res.detail.routes.length){

                                        res.detail.routes.map((item,id)=>{
                                            let name = '方案' + (id+1);

                                            let time = '约';

                                            let h = Math.floor(item.duration / 60),
                                                m = item.duration%60;


                                            if(h>0)time += h + '小时';
                                            time += m + '分钟';

                                            time +='/'+Math.ceil(item.distance/1000) +'公里';

                                            this.routeLines.push({
                                                name:name,
                                                time:time,
                                                id:id     //index为标识
                                            })
                                        })
                                    }

                                }

                            };

                            this.drivingService(start,end,callback);
                            // this.drivingService('重庆北站','广东南站',callback);

                        }

                        else{

                            let callback = (res,type)=>{

                                if(type == 'err'){
                                    this.routeLoad = false;
                                }

                                else if(type == '1'){
                                    //起终点不唯一
                                    let s,e;
                                    s = getItem(res.detail.start,startPoi);
                                    e = getItem(res.detail.end,endPoi);

                                    // console.log('s',s,'e',e)

                                    if(s.latLng && s.latLng.lat && e.latLng && e.latLng.lat){
                                        this.transferService(s.latLng,e.latLng,callback);
                                    }else{
                                        this.routeLoad = false;
                                    }
                                }

                                else{

                                    this.routeLoad = false;
                                    this.routeLines = [];
                                    if(res.detail.plans && res.detail.plans.length){
                                        res.detail.plans.map((item,id)=>{

                                            let name = '';
                                            item.lines.map(child=>{
                                                name +=child.name+'、'
                                            });
                                            name = name.slice(0,name.length-1);

                                            let time = '约';

                                            let h = Math.floor(item.duration / 60),
                                                m = item.duration%60;

                                            if(h>0)time += h + '小时';
                                            time += m + '分钟';
                                            time +='/'+Math.ceil(item.distance/1000) +'公里';


                                            this.routeLines.push({
                                                name:name,
                                                time:time,
                                                id:id //索引作为标识
                                            })
                                        })
                                    }

                                }
                                // console.log('乘车规划路线',res);
                            }
                            //公交规划路线信息
                            this.transferService(start,end,callback);

                            // this.transferService('重庆北站','广东南站',callback);

                        }

                    }
                    else{
                        this.routeLoad = false;
                    }

                };


                if(!startPoi){

                    if(this.$qqmap.currentLatlng){
                        startPoi = JSON.stringify({name:'我的位置',latlng:this.$qqmap.currentLatlng});
                        callback && callback();
                    }

                    else{
                        this.getGPSLocation((res,err)=>{

                            if(err){
                                this.$message.info(`${res},请先手动选择起点`);
                                startPoi = JSON.stringify({});
                                callback && callback();

                            }else{
                                startPoi = JSON.stringify({name:'我的位置',latlng:this.$qqmap.currentLatlng});
                                callback && callback();
                            }
                        })
                    }

                }
                else{
                    callback && callback();
                }

            },

            changeRoute(){
                this.getRoute(this.vechileIndex+1,'change')
            },

            routeLinesEvent(item){

                // this.$message.info('该功能正在努力开发中....');
                // return;

                let query = this.$route.query;

                query.model = 'routeToLine';
                query.id = item.id;
                query.type = this.vechileIndex + 1;
                query.vechileIndex = this.vechileIndex + 1;//规划方式

                if(this.$qqmap.drivingService)this.$qqmap.drivingService.clear();
                if(this.$qqmap.transferService)this.$qqmap.transferService.clear();

                this.$router.replace({
                    path:'/qqMap',
                    query:query
                })


            }
        },

        activated() {
            this.getRoute();
        },

        mounted() {
            this.getRoute();
        }
    }
</script>

<style lang="less">
    @import "../../../styles/index";
    .qqmap-route-conatiner{

        @height:@standartHeightA4;
        @space:@standartSpaceA4;

        .active(){
            &:active{
                background-color: @bodyBgColor;
            }
        }

        color: @fontColorA2;

        display: flex;
        flex-direction: column;


        >.route-head-section{

            background-color: @themeReverseColor;
            box-shadow: @shadowbox;
            flex-shrink: 0;
            margin-bottom: @20px;

            >.startAndEnd-chunk{
                display: flex;
                align-items: center;
                padding: @space/2 0px;

                >.back,>.change-route{
                    flex-shrink: 0;
                    .flexCenter();
                    padding:0px @space;

                }

                >.back{
                    >i{
                        height: @height;
                        width: @height;
                        .flexCenter();
                        box-shadow: @shadowbox;
                        border-radius: @radiusNumber;
                        .active();
                        font-size: @normalFontSize;
                    }
                }

                >.change-route{
                    >i{
                        font-size: @fontSizeA2;
                        &:active{
                            opacity: .8;
                        }
                    }
                }

                >.input-group{
                    flex: 1;
                    overflow: hidden;

                    display: flex;
                    align-items: flex-start;

                    >.l{
                        .flexCenter();
                        height: 2 * @height;
                        margin-right: @space/2;

                        >.wrap{

                            display: flex;
                            flex-direction: column;
                            height: 55%;
                            @var:@16px;
                            >.dot{
                                display: inline-block;
                                width: @var;
                                height: @var;
                                border-radius: @var/2;
                                background-color: @themeReverseColor;
                                flex-shrink: 0;

                                &.start{
                                    border: 2px solid @successColor;
                                }

                                &.end{
                                    border: 2px solid @warningColor;
                                }
                            }

                            >.rail{
                                flex: 1;
                                display: block;
                                @bw:@2px;
                                margin-left: (@var - @bw)/2;
                                border-left: @bw dashed @borderColorA1;
                            }
                        }
                    }

                    >.r{
                        flex: 1;
                        >.box{
                            border-bottom: 1px solid @borderColorA1;
                            .active();
                            &:last-child{
                                border-bottom: none;
                            }
                            >input{
                                height: @height;
                                width: 100%;
                                padding-left: @8px;
                            }
                        }
                    }
                }

            }


            >.vechile-chunk{
                display: flex;
                >a{
                    flex: 1;
                    height: @height;
                    .flexCenter();
                    position: relative;

                    >i{
                        font-size: @fontSizeA1;
                        vertical-align: middle;
                        margin-right: @10px;
                        &.icon-gongjiaoche{
                            font-size: @fontSizeA2;
                        }
                    }

                    &.active{
                        color: @themeColor;
                        &:after{
                            content: "";
                            display: block;
                            .absoluteByCover();
                            top: auto;
                            bottom: -1px;
                            border-bottom: 2px solid @themeColor;
                        }
                    }

                    &:active{
                        color: @themeColor;
                    }

                }
            }
        }

        >.route-body-section{

            flex: 1;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;

            >.routeLine-chunk{

                background-color: @themeReverseColor;

                >ul{
                    >li{
                        display: flex;
                        @var:@50px;
                        padding: @space 0px;
                        border-bottom: 1px solid @borderColorA2;

                        &:active{
                            background-color: fade(#0465ef,10%);
                        }

                        >.l{
                            padding: 0px @space;
                            flex-shrink: 0;
                            >span{
                                width: @var;
                                height: @var;
                                border-radius: @var/2;
                                .flexCenter();
                                color: @themeColor;
                                background-color: fade(#0465ef,30%);
                            }
                        }

                        >.r{
                            flex: 1;
                            overflow: hidden;

                            >.p1{
                                font-size: @fontSizeA3;
                                color: #333333;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }

                            >.p2{
                                font-size: @fontSizeA5;
                                color: @fontColorA3;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                    }
                }

                >.load-box{
                    .loadDataBox();
                    height: @400px;
                }

                >.empty-box{
                    height: @400px;
                    .flexCenter();
                    >.wrap{

                        text-align: center;
                        >i{
                            font-size: @fontSizeA1;
                        }
                        >span{
                            display: block;
                            text-align: center;
                        }
                    }
                }
            }
        }

    }
</style>
